import { createContext, useState } from "react";
// import { process.env.REACT_APP_BACKEND_URL } from "../utils/Secrets";
import axios from "axios";
var BACKEND_URL = "";
if(process.env.NODE_ENV==="development"){
BACKEND_URL = process.env.REACT_APP_DEV_KEY;
}if(process.env.NODE_ENV==='production'){
  BACKEND_URL = process.env.REACT_APP_API_KEY;
}
export const StudentDetailsContext = createContext({
  personalDetails: [],
  feeDetails: [],
  getDetailsByClassName: (id) => {},
  updateDetailsByAdmission: (id) => {},
  addDetailsByAdmission: (classId, admissionId) => {},
  deleteDetailsByAdmission: (id,className) => {},
  studentDetailsByClassName: [],
  updateStudentDetailsByAdmissionNumber: (admissionId) => {},
  loading:false,
  isUpdated:false,
  created:false,
  getStudentDetailsByAdmission : (id)=>{},
  uploadExamMarksByAdmissionNumber:(id)=>{},
  getAllStudentMarks:(examName)=>{},
  studentMarksArr : [],
  deleteExamMarksByAdmission:(id)=>{},
  removedStudent : false,
  updateCreatedState : ()=>{},
  updateFeeDetails:(AdmissionNumber,Amount,currentDate)=>{},
  loadFeeDetails:(AdmissionNumber)=>{},
  uploadAttendance:(AdmissionNumber,monthName,workingDays,presentDays,absentDays)=>{}
});

function StudentDetailsContextProvider({ children }) {
  const [personalDetails, setPersonalDetails] = useState({});
  const[loading,setIsLoading] = useState(false);
  const[updated,setIsUpdated] = useState(false);
  const[created,setIsCreated] = useState(false);
  const[removedStudent,setRemovedStudent] = useState(false);

  const [studentDetailsByClassName, setStudentDetailsByClassName] = useState(
    []
  );
  const [studentMarksArr,setStudentMarksArr] = useState([]);
  const[feeDetails,setFeeDetails] = useState([]);
  async function addDetailsByAdmission(classId, admissionId, formBody) {
    let className = classId;
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const {
      Name,
      FatherName,
      MotherName,
      AdmissionNumber,
      AdmissionDate,
      AadharNumber,
      MobileNumber,
      Dob,
    } = formBody;
    const body = {
      Name,
      FatherName,
      MotherName,
      AdmissionNumber,
      AdmissionDate,
      AadharNumber,
      MobileNumber,
      Dob,
    };
    const response = await axios
      .post(BACKEND_URL + "/Student/add/new/"+className, body, config)
      .then((data) => {
        setIsLoading(true);
        setStudentDetailsByClassName(data.data);
        setIsCreated(true);
        console.log(response);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error Occurred : " + err.message);
      });
  }

   async function getDetailsByClassName(classId) {
      try {
        setIsLoading(true);
        const response = await axios.get(BACKEND_URL + "/Student/get/" + classId);
        if(response){
          setStudentDetailsByClassName(response.data);
        }
        setIsLoading(false);

      } catch (error) {
        console.log("Error Occurred : " + error.message);

      }
  }
  

  async function updateStudentDetailsByAdmissionNumber(
    className,
    admissionId,
    formBody
  ) {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const {
      Name,
      FatherName,
      MotherName,
      AdmissionNumber,
      AdmissionDate,
      AadharNumber,
      MobileNumber,
      Dob,
    } = formBody;
    const body = {
      Name,
      FatherName,
      MotherName,
      AdmissionNumber,
      AdmissionDate,
      AadharNumber,
      MobileNumber,
      Dob,
    };

      let classId = className;
      const response = await axios
        .put(
          BACKEND_URL + "/Student/update/" +classId+"/"+admissionId,
          body,
          config
        )
        .then((data) => {
          console.log("After updating student details : " , data.data);
          setIsLoading(true);
          setStudentDetailsByClassName(data.data);
          setIsLoading(false);
          setIsUpdated(true);
          console.log('response : ',response);
        })
        .catch((err) => {
          console.log("Error Occurred : " + err.message);
        });
    
  }
  async function deleteDetailsByAdmission(admissionNumber,className){
    const response = await axios.delete(BACKEND_URL+"/Student/delete/"+className+"/"+admissionNumber).then((data)=>{
        setIsLoading(true);
        setStudentDetailsByClassName(data.data);
        setIsLoading(false);
        console.log('response : ',response);

    }).catch((err)=>{
        console.log('Error Occurred : '+err.message);
    })
  }

  async function getStudentDetailsByAdmission(admissionNumber){
    const response = await axios.get(BACKEND_URL+"/Student/get/details/"+admissionNumber).then((data)=>{
      // console.log("Student Details By Admission Number : ",data.data);
      setPersonalDetails(data.data);
      console.log('response : ',response);

    }).catch((err)=>{console.log("Error Occurred : "+err.message)})
  }

  async function uploadExamMarksByAdmissionNumber(admissionId,examName,className,studentName,formData){
    const config = {
      headers:{
        'Content-Type':'application/json'
      }
    }
    const body =  formData;
    const response = await axios.post(BACKEND_URL+`/Exams/${examName}/${className}/${admissionId}/${studentName}/upload/marks`,body,config).then((data)=>{
      setIsLoading(true);
      console.log('uploaded to db: ',data.data);
      setIsCreated(true);
      setIsLoading(false);
      console.log(response);
    }).catch((err)=>{
      console.log('Error Occurred : '+err.message);
    })
  }
  async function getAllStudentMarks(examName){
    const response = await axios.get(BACKEND_URL+"/Exams/all/"+examName).then((data)=>{
      setIsLoading(true);
      setStudentMarksArr(data.data);
      setIsLoading(false);
      console.log(response);
    }).catch((err)=>{
      console.log('Error Occurred : '+err.message);
    })
  }
  async function deleteExamMarksByAdmission(examId){
    const response = await axios.delete(BACKEND_URL+`/Exams/delete/${examId}`).then((data)=>{
      setIsLoading(true);
      setStudentMarksArr(data.data);
      setIsLoading(false);
      setRemovedStudent(true);
      console.log(response);
    }).catch((err)=>{
      console.log('Error Occurred : '+err.message);
    })
  }
  async function updateCreatedState(){
    setIsCreated(false);
  }

  async function updateFeeDetails(AdmissionNumber,Amount,Date){
    const config = {
      headers:{
        "Content-Type":"application/json"
      }
    }
    const body = {AdmissionNumber,Amount,Date}

    setIsLoading(true);
    const response = await axios.post(BACKEND_URL+"/StudentRoutes/FeeDetails/update/AdmissionNumber/"+AdmissionNumber+"/Amount/"+Amount+"/Date/"+Date,body,config).then((data)=>{
     
      console.log("After Updating Fee Details");
      setIsLoading(false);
      console.log(data.data);
      
      console.log("Updated Successfully!");
      function setTimeOutFun(){
        setTimeout(() => {
          // Update the state variable after 2 seconds
          setIsUpdated(false);

        }, 5000); // 2000 milliseconds (2 seconds)
       }
        setTimeOutFun();
      console.log(response);

    }).catch((err)=>{

      setIsLoading(false);
      setIsCreated(false);

    })
  } 
  async function loadFeeDetails(AdmissionNumber){
    setIsLoading(true);
    const response = await axios.get(BACKEND_URL+"/StudentRoutes/FeeDetails/get/AdmissionNumber/"+AdmissionNumber).then((data)=>{
      setFeeDetails(data.data);
      setIsLoading(false);
      console.log(data.data);
    }).then((err)=>{
      console.log("Error Occurred");
      setIsLoading(false);
    })
    console.log(response);
  }

  async function uploadAttendance(AdmissionNumber,monthName,workingDays,presentDays,absentDays){
    const body = {AdmissionNumber,monthName,workingDays,presentDays,absentDays}
    const config = {
      headers:{
        'Content-Type':'application/json'
      }
    }
    try {
      setIsLoading(true);
      const response = await axios.post(BACKEND_URL+`/StudentRoutes/Attendance/AdmissionNumber/${AdmissionNumber}/month/${monthName}/working/${workingDays}/present/${presentDays}/absent/${absentDays}`,body,config);
      if(response){
        console.log("response : ")
        console.log(response.data);
        if(response.data === "Attendance Uploaded Successfully!"){
          setIsUpdated(true);
          setIsLoading(false);
         function setTimeOutFun(){
          setTimeout(() => {
            // Update the state variable after 2 seconds
            setIsUpdated(false);

          }, 5000); // 2000 milliseconds (2 seconds)
         }
          setTimeOutFun();
        }
      }else{
        console.log("No response !!");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error Occurred !!"+error.message);
      setIsLoading(false);
    }
  }

  const value = {
    personalDetails: personalDetails,
    addDetailsByAdmission: addDetailsByAdmission,
    getDetailsByClassName: getDetailsByClassName,
    studentDetailsByClassName: studentDetailsByClassName,
    updateStudentDetailsByAdmissionNumber:
    updateStudentDetailsByAdmissionNumber,
    deleteDetailsByAdmission:deleteDetailsByAdmission,
    loading : loading,
    isUpdated : updated,
    created:created,
    getStudentDetailsByAdmission:getStudentDetailsByAdmission,
    uploadExamMarksByAdmissionNumber:uploadExamMarksByAdmissionNumber,
    getAllStudentMarks:getAllStudentMarks,
    studentMarksArr:studentMarksArr,
    deleteExamMarksByAdmission:deleteExamMarksByAdmission,
    removedStudent:removedStudent,
    updateCreatedState:updateCreatedState,
    updateFeeDetails:updateFeeDetails,
    loadFeeDetails:loadFeeDetails,
    feeDetails:feeDetails,
    uploadAttendance:uploadAttendance
  };
  return (
    <>
      <StudentDetailsContext.Provider value={value}>
        {children}
      </StudentDetailsContext.Provider>
    </>
  );
}

export default StudentDetailsContextProvider;
